export const generateVertices = () => {
  const vertices = [];
  for (let i = 0; i < 16; i++) {
    vertices.push([
      (i & 1) ? 1 : -1,
      (i & 2) ? 1 : -1,
      (i & 4) ? 1 : -1,
      (i & 8) ? 1 : -1,
    ]);
  }
  return vertices;
};

export const generateEdges = () => {
  const edges = [];
  for (let i = 0; i < 16; i++) {
    for (let j = i + 1; j < 16; j++) {
      const diff = i ^ j;

      if (diff && (diff & (diff - 1)) === 0) {
        edges.push([i, j]);
      }
    }
  }
  return edges;
};

export const classifyEdge = (indexA, indexB) => {
  const diff = indexA ^ indexB;
  if (diff === 1) return 0; 
  if (diff === 2) return 1; 
  if (diff === 4) return 2; 
  if (diff === 8) return 3; 
  return -1;
};

export const rotate4D = (vertex, angles) => {
  const v = [...vertex];
  const { xw = 0, yw = 0, zw = 0, xy = 0, xz = 0, yz = 0 } = angles;

  if (xw) {
    const c = Math.cos(xw), s = Math.sin(xw);
    const x = v[0] * c - v[3] * s;
    const w = v[0] * s + v[3] * c;
    v[0] = x; v[3] = w;
  }

  if (yw) {
    const c = Math.cos(yw), s = Math.sin(yw);
    const y = v[1] * c - v[3] * s;
    const w = v[1] * s + v[3] * c;
    v[1] = y; v[3] = w;
  }

  if (zw) {
    const c = Math.cos(zw), s = Math.sin(zw);
    const z = v[2] * c - v[3] * s;
    const w = v[2] * s + v[3] * c;
    v[2] = z; v[3] = w;
  }

  if (xy) {
    const c = Math.cos(xy), s = Math.sin(xy);
    const x = v[0] * c - v[1] * s;
    const y = v[0] * s + v[1] * c;
    v[0] = x; v[1] = y;
  }

  if (xz) {
    const c = Math.cos(xz), s = Math.sin(xz);
    const x = v[0] * c - v[2] * s;
    const z = v[0] * s + v[2] * c;
    v[0] = x; v[2] = z;
  }

  if (yz) {
    const c = Math.cos(yz), s = Math.sin(yz);
    const y = v[1] * c - v[2] * s;
    const z = v[1] * s + v[2] * c;
    v[1] = y; v[2] = z;
  }

  return v;
};

export const project4Dto3D = (vertex, viewDistance = 3) => {
  const scale = viewDistance / (viewDistance - vertex[3]);
  return [
    vertex[0] * scale,
    vertex[1] * scale,
    vertex[2] * scale,
  ];
};

export const transformTesseract = (angles, viewDistance = 3) => {
  const vertices4D = generateVertices();
  const edges = generateEdges();
  const projected = vertices4D.map(v => {
    const rotated = rotate4D(v, angles);
    return project4Dto3D(rotated, viewDistance);
  });
  return { projected, edges };
};

export const generateFaces = () => {
  const faces = [];

  const axes = [0, 1, 2, 3];
  for (let a = 0; a < 4; a++) {
    for (let b = a + 1; b < 4; b++) {

      const fixed = axes.filter(x => x !== a && x !== b);

      for (let fv = 0; fv < 4; fv++) {
        const f0 = (fv & 1) ? 1 : -1;
        const f1 = (fv & 2) ? 1 : -1;

        const quad = [];
        for (let i = 0; i < 16; i++) {
          const v = [
            (i & 1) ? 1 : -1,
            (i & 2) ? 1 : -1,
            (i & 4) ? 1 : -1,
            (i & 8) ? 1 : -1,
          ];
          if (v[fixed[0]] === f0 && v[fixed[1]] === f1) {
            quad.push(i);
          }
        }
        if (quad.length === 4) {

          const sorted = [quad[0]];
          const remaining = quad.slice(1);
          for (let s = 0; s < 3; s++) {
            const last = sorted[sorted.length - 1];
            const nextIdx = remaining.findIndex(r => {
              const diff = last ^ r;
              return diff && (diff & (diff - 1)) === 0;
            });
            if (nextIdx >= 0) {
              sorted.push(remaining.splice(nextIdx, 1)[0]);
            }
          }
          faces.push(sorted);
        }
      }
    }
  }
  return faces;
};

// 8 cubic cells of the tesseract — each fixes one 4D axis at ±1
// Returns array of { axis, sign, center4D, vertexIndices }
export const generateCells = () => {
  const cells = [];
  for (let axis = 0; axis < 4; axis++) {
    for (const sign of [-1, 1]) {
      const center = [0, 0, 0, 0];
      center[axis] = sign;
      const verts = [];
      for (let i = 0; i < 16; i++) {
        const v = [
          (i & 1) ? 1 : -1,
          (i & 2) ? 1 : -1,
          (i & 4) ? 1 : -1,
          (i & 8) ? 1 : -1,
        ];
        if (v[axis] === sign) verts.push(i);
      }
      cells.push({ axis, sign, center4D: center, vertexIndices: verts });
    }
  }
  return cells;
};

export const EDGE_COLORS = [
  0x00ffff, 
  0xff00ff, 
  0xffff00, 
  0xffffff, 
];

export const VERTEX_COLOR = 0x88ccff;
